import { Permissions, security } from "Common/permissions";
import { PageObject, ROUTE_ANCHOR, registerRouting } from "Common/routingUtils";
import hashes from "./routesMap.hash";
import locale from "./routesMap.locale";
import routingKeys from "./routingKeys";
import Welcome from "./welcome";
import WorkSpaceDetails from "./workSpaceDetails";
registerRouting(routingKeys.WELCOME, new PageObject(Welcome, {
    hash: hashes.WELCOME,
    locale: locale.WELCOME
}, null, true, () => `${ROUTE_ANCHOR}${hashes.WELCOME}`));
if (security.isAllowed([Permissions.WorkSpacesView])) {
    registerRouting(routingKeys.WORK_SPACE, new PageObject(WorkSpaceDetails, {
        hash: `${hashes.WORK_SPACE}/(?<id>(?!0$)\\d+)`,
        locale: locale.WORK_SPACE
    }, null, false, id => {
        if (!Number.isFinite(Number(id)) || id <= 0)
            return null;
        return `${ROUTE_ANCHOR}${hashes.WORK_SPACE}/${id}`;
    }));
}
